import { useContext } from 'react';
import { LoginModalContext } from 'src/contexts/ModalLoginProvider';

const useModalLogin = () => {
  return useContext(LoginModalContext);
};

export default useModalLogin;
